import React from "react";
import styles from "./WaysToStyleModalCarousel.scss";
import StylingLookHeroImage from "./StylingLookHeroImage";
import { useWaysToStyle } from "../../context/waysToStyle/WaysToStyleContext";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import useCarouselAnimationScroll from "./useCarouselAnimationScroll";
import LookLabel from "./LookLabel";

export default function WaysToStyleModalCarousel({
  selectedIndex,
  isOpen,
}: {
  selectedIndex: number;
  isOpen: boolean;
}) {
  const { stylingLooks } = useWaysToStyle();
  const containerRef = useCarouselAnimationScroll(selectedIndex, isOpen);
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  return (
    <section
      className={styles.container}
      ref={containerRef}
      data-testid="modalCarouselContainer"
      aria-label={getTranslation("pdp_ways_to_style_title")}
      aria-roledescription="carousel"
    >
      {stylingLooks.map((look, lookIndex) => (
        <div className={styles.lookCarouselItem} key={lookIndex}>
          <StylingLookHeroImage
            look={look}
            index={lookIndex}
            additionalClasses={styles.heroImage}
          />
          <LookLabel look={look} additionalClasses={styles.modalLookLabel} />
        </div>
      ))}
    </section>
  );
}
